import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { CreateBadgeRequest } from "@shopexperts/legacy-api";

export function useCreateBadge() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, error } = useMutation({
    mutationFn: (data: CreateBadgeRequest) => {
      return api.admin.badges.createBadge({ body: data });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'badges'] });
      toaster.create({
        title: "Badge created successfully",
        type: "success",
      });
    },
    onError: (error) => {
      toaster.create({
        title: "Failed to create badge",
        description: error.message || "An error occurred",
        type: "error",
      });
      console.error('[useCreateBadge] Error:', error);
    },
  });

  return { mutate, mutateAsync, isPending, error };
}

export default useCreateBadge;

